// Composables
import { createRouter, createWebHistory } from 'vue-router'
import verifiedAgentList from '@/views/VerifiedAgentList.vue'
import AgentWaitList from '@/views/AgentWaitList.vue'
import AgentInformation from '@/views/VerifiedAgentInfo.vue'
import IncidentDetail from '@/views/IncidentDetail.vue'
import SelectAgentOnIncidentCreation from '@/views/SelectAgentOnIncidentCreation.vue'
import CustomerList from '@/views/CustomerList.vue'
import CustomerListInfo from '@/views/CustomerListInfo.vue'
import PersonnelList from '@/views/PersonnelList.vue'
import RoleList from '@/views/RoleList.vue'
import UserProfile from '@/views/UserProfile.vue'
import ClientDemand from '@/views/ClientDemand.vue'
import createStore from '@/store/index'
import notification from '@/services/API/notification'
const routes = [
	{
		path: '/login',
		name: 'login',
		component: () => import('@/layouts/default/AdminLogin.vue'),
	},
	{
		path: '/',
		name: 'adminDashboard',
		component: () => import('@/layouts/default/Default.vue'),
		children: [
			{
				path: '/',
				name: 'Home',
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: () =>
					import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
			},
			{
				path: '/incident-detail',
				name: 'IncidentDetail',
				component: IncidentDetail,
			},
			{
				path: '/create-incident',
				name: 'CreateIncident',
				component: () => import('@/views/CreateIncident.vue'),
			},
			{
				path: '/create-esg-incident',
				name: 'CreateEsgIncident',
				component: () => import('@/views/CreateEsgIncident.vue'),
			},
			{
				path: '/agent-list/verified-agent',
				name: 'VerifiedAgentList',
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: verifiedAgentList,
			},
			{
				path: '/agent-list/agent-wait-list',
				name: 'AgentWaitList',
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				component: AgentWaitList,
			},
			{
				path: '/agent-list/verified-agent/agent-information',
				name: 'AgentInformation',
				component: AgentInformation,
			},
			{
				path: '/create-incident/select-agent',
				name: 'SelectAgent',
				component: SelectAgentOnIncidentCreation,
			},
			{
				path: '/demand-list',
				name: 'DenamdList',
				component: ClientDemand,
			},
			{
				path: '/customer-list',
				name: 'CustomerList',
				component: CustomerList,
			},
			{
				path: '/customer-list/customer-information',
				name: 'CustomerInformation',
				component: CustomerListInfo,
			},
			{
				path: '/personnel-list',
				name: 'PersonnelList',
				component: PersonnelList,
			},
			{
				path: '/role-list',
				name: 'RoleList',
				component: RoleList,
			},
			{
				path: '/user-profile',
				name: 'UserProfile',
				component: UserProfile,
			},
		],
	},
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
})

router.beforeEach((to) => {
	// Check if user session has expired
	let days = 30
	let now = new Date().getTime()
	let setupTime = localStorage.getItem('setupTime') * 1
	if (now - setupTime > days * 24 * 60 * 60 * 1000) {
		localStorage.clear()
		// location.reload();
	}

	// Redirect to login page if user is not authenticated

	if (
		to.name !== 'login' &&
		to.name !== 'adminDashboard' &&
		!localStorage.getItem('Authentication')
	) {
		return { name: 'login' }
	}
})

router.afterEach(async () => {
	try {
		const response = await notification.getNotifications()
		if (response.status === 200) {
			createStore.state.notifications = response.data.notifications
		}
		console.log('Routed', createStore.state.notifications)
	} catch (error) {
		console.error('Failed to fetch notifications:', error)
	}
})

export default router
